import { useEffect, useState } from "react";
import { MapPin, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { BOOKSY_URL } from "@/lib/config";

const QUICK_MENU = [["Basic Haircut", 30], ["Wash & Cut", 40], ["Line Up", 10], ["Straight Razor", 25]];

const HeroInfo = () => (
  <div className="grid md:grid-cols-[1.4fr_1fr] gap-10 md:gap-16 items-end">
    <div>
      <div className="text-xs tracking-[0.3em] uppercase text-white/40 mb-5">The Menu</div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-4">
        {QUICK_MENU.map(([name, price]) => (
          <div key={name} data-testid={`hero-service-${name.toLowerCase().replace(/[^a-z]+/g, "-")}`} className="flex flex-col">
            <span className="text-sm uppercase tracking-[0.15em] text-white/80 font-medium leading-snug">{name}</span>
            <span className="font-mono text-2xl font-bold text-[#CCFF00] mt-1">${price}</span>
          </div>
        ))}
      </div>
      <a href="#services" data-testid="hero-view-all-services" className="inline-block mt-5 text-xs tracking-[0.25em] uppercase text-white/50 hover:text-[#FF3333] transition-colors">
        View all 9 services →
      </a>
    </div>
    <div className="space-y-4 border-l-2 border-[#FF3333] pl-6">
      <a data-testid="hero-address" href="https://www.google.com/maps/search/?api=1&query=2006+Prairie+Rd+Monroe+LA+71202" target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-white/80 hover:text-white transition-colors">
        <MapPin className="w-5 h-5 text-[#FF3333] shrink-0 mt-0.5" />
        <span className="font-mono text-sm uppercase">2006 Prairie Rd<br />Monroe, LA 71202</span>
      </a>
      <div data-testid="hero-hours" className="flex items-start gap-3 text-white/80">
        <Clock className="w-5 h-5 text-[#FF3333] shrink-0 mt-0.5" />
        <span className="font-mono text-sm uppercase">By appointment<br />Live availability on Booksy</span>
      </div>
    </div>
  </div>
);

export default function Hero() {
  const [images, setImages] = useState([]);
  useEffect(() => {
    api.get("/gallery").then((r) => setImages(r.data.images.slice(1, 5))).catch(() => {});
  }, []);

  return (
    <section id="hero" className="relative pt-28 md:pt-32 pb-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="fade-up">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-12 bg-[#FF3333]" />
            <span className="text-xs tracking-[0.3em] uppercase font-bold text-[#FF3333]">Monroe, Louisiana</span>
          </div>
          <h1 data-testid="hero-name" className="font-display font-black uppercase tracking-tighter leading-[0.8] text-[17vw] md:text-[13vw] xl:text-[11rem]">
            McNeal <span className="text-transparent" style={{ WebkitTextStroke: "2px #FF3333" }}>Cutz</span>
          </h1>
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mt-8">
            <p data-testid="hero-headline" className="font-display font-black uppercase text-3xl md:text-5xl tracking-tight leading-none">
              A House Call <span className="bg-[#FF3333] text-black px-3 italic">Away</span>
            </p>
            <div className="flex flex-col sm:flex-row gap-4">
              <a data-testid="hero-book-btn" href={BOOKSY_URL} target="_blank" rel="noopener noreferrer" className="bg-[#FF3333] street-btn font-bold uppercase tracking-widest text-sm px-10 py-5 hover:bg-[#FF5C5C] text-center">
                Book on Booksy →
              </a>
              <a href="#services" data-testid="hero-services-btn" className="border border-white/30 text-white font-bold uppercase tracking-widest text-sm px-10 py-5 hover:bg-white/5 hover:border-white transition-colors text-center">
                View Services
              </a>
            </div>
          </div>
        </div>

        <div data-testid="hero-photo-strip" className="grid grid-cols-2 md:grid-cols-[2fr_1fr_1fr_1fr] md:h-[420px] gap-2 mt-12 mb-14">
          {images.map((src, i) => (
            <div key={src} className={`overflow-hidden border border-white/10 ${i === 0 ? "col-span-2 md:col-span-1 aspect-[16/10] md:aspect-auto" : "aspect-[3/4] md:aspect-auto"} ${i === 3 ? "hidden md:block" : ""}`}>
              <img src={src} alt={`McNeal Cutz cut ${i + 1}`} data-testid={`hero-photo-${i}`} className="w-full h-full object-cover hover:scale-105" />
            </div>
          ))}
        </div>

        <div className="pt-8 border-t border-white/10">
          <HeroInfo />
        </div>
      </div>
    </section>
  );
}
